import { render, staticRenderFns } from "./StatusDaCampanha.vue?vue&type=template&id=a290313a&"
import script from "./StatusDaCampanha.vue?vue&type=script&lang=js&"
export * from "./StatusDaCampanha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports